module.exports = __webpack_public_path__ + "img/stamp.241740ab.svg";